export const getTranslations = (state, region) => {
  return JSON.parse(state.metadata.translations).language[region];
};
